import { render, staticRenderFns } from "./AdminCartComponent.vue?vue&type=template&id=8fbf49ae&scoped=true"
import script from "./AdminCartComponent.vue?vue&type=script&lang=js"
export * from "./AdminCartComponent.vue?vue&type=script&lang=js"
import style0 from "./AdminCartComponent.vue?vue&type=style&index=0&id=8fbf49ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbf49ae",
  null
  
)

export default component.exports